<button tabindex="2" [attr.aria-label]="label" appAutofocus type="button"
        class=" border-4 rounded-full inline-flex items-center justify-center py-3 px-6 my-1 cursor-pointer
  text-center text-base font-medium  font-theme-source w-full"

        [class.border-theme-green-110]="selected"
        [class.bg-theme-green-110]="selected"
        [class.text-white]="selected"

        [class.bg-white]="!selected"
        [class.border-theme-black]="!selected"
        [class.text-theme-black]="!selected"
        [class.hover:text-white]="!selected"
        [class.hover:bg-theme-green-110]="!selected"
        [class.hover:border-theme-green-110]="!selected"
>
  <i class="fa-solid fa-check mr-2  text-2xl" *ngIf="selected"></i>{{ label }}
</button>
